/**
 * Shared module-level state for sidebar panel hooks.
 *
 * These variables are intentionally module-scoped (not per-instance) to enable
 * cross-component communication. Multiple components (NavItem, SidebarPanel)
 * use different hooks that need to coordinate:
 *   - NavItem can start a hide timeout
 *   - SidebarPanel can cancel that SAME timeout when mouse enters
 *
 * Accessor functions are used because ES module `let` bindings cannot be
 * reassigned from importing modules.
 */

export const HIDE_DEBOUNCE_MS = 150;
export const SHOW_DEBOUNCE_MS = 150;

// =============================================================================
// SHARED TIMEOUT STATE
// =============================================================================

let sharedHideTimeout: ReturnType<typeof setTimeout> | null = null;
let sharedShowTimeout: ReturnType<typeof setTimeout> | null = null;

export function clearSharedHideTimeout() {
  if (sharedHideTimeout) {
    clearTimeout(sharedHideTimeout);
    sharedHideTimeout = null;
  }
}

export function clearSharedShowTimeout() {
  if (sharedShowTimeout) {
    clearTimeout(sharedShowTimeout);
    sharedShowTimeout = null;
  }
}

export function setSharedHideTimeout(timeout: ReturnType<typeof setTimeout>): void {
  sharedHideTimeout = timeout;
}

export function setSharedShowTimeout(timeout: ReturnType<typeof setTimeout>): void {
  sharedShowTimeout = timeout;
}

// =============================================================================
// SHARED SIDEBAR ELEMENT
// =============================================================================

let sharedSidebarElement: HTMLDivElement | null = null;

export function getSharedSidebarElement(): HTMLDivElement | null {
  return sharedSidebarElement;
}

export function setSharedSidebarElement(element: HTMLDivElement | null): void {
  sharedSidebarElement = element;
}
